import * as React from "react";
import { useContext } from "react";
import ReactTableWithSettings from "../../../../../../../components/material_react_table/react_table_with_settings";
import { REACT_TABLE_NAMES } from "../../../../../../../enums/react_table_name_enum";

import { CommissioningStateContext } from "../../hooks/use_commissioning_state_changes";
import { toDate } from "../../../../../../../scripts/utils";
import GeneralValidationErrorCard from "./general_validation_errors_card";
import DeviceValidationErrorCard from "./device_validation_error_card";

export const DeviceCommissioningOverview = ({}) => {
  const { commissioningState, commissioningError, isLoadingCommissioning } = useContext(CommissioningStateContext);

  function sanitizeData(data) {
    if (!data) return [];
    else {
      const allKeys = data.length > 0 ? Object.keys(data[0]) : [];
      const dateKeys = [];
      allKeys.forEach((key) => {
        const lowerKey = key.toLowerCase();
        if (lowerKey.includes("date")) {
          dateKeys.push(key);
        }
      });
      return data.map((row) => {
        const sanitizedRow = { ...row };
        dateKeys.forEach((key) => {
          // commissioning_completed_date is the only one currently and is a utc date for now
          sanitizedRow[key] = toDate(sanitizedRow[key]);
        });
        return sanitizedRow;
      });
    }
  }

  const sanitized_device_data = React.useMemo(
    () => sanitizeData(commissioningState.deviceCommissioningOverview),
    [commissioningState.deviceCommissioningOverview],
  );

  const overview_columns = [
    { accessorKey: "device_id", header: "Device ID" },
    { accessorKey: "name", header: "Device name" },
    { accessorKey: "commissioning_status", header: "Commissioning status" },
    //{accessorKey: 'validation_errors', header: 'Validation errors'}, // We've added a card with device specific errors below.
    { accessorKey: "device_type", header: "Device type" },
    { accessorKey: "device_class", header: "Device class" },
    {
      accessorKey: "commissioning_completed_date_utc",
      header: "Completed date",
      enableGlobalFilter: false,
      filterVariant: "datetime-range",
      Cell: ({ cell }) => (cell.getValue() ? cell.getValue().toLocaleString() : null),
      sortingFn: "customDateSortingFn",
      filterFn: "customDatetimeRangeFilter",
    },
  ];

  return (
    <div style={{ padding: "10px" }}>
      <ReactTableWithSettings
        unique_table_key={REACT_TABLE_NAMES.DEVICE_COMMISSIONING_OVERVIEW}
        columns={overview_columns}
        defaultSorting={[{ id: "validation_errors", desc: true }]}
        data={sanitized_device_data}
        error={commissioningError}
        isLoading={isLoadingCommissioning}
      />
      {commissioningState.validationState.has_general_validation_errors && (
        <GeneralValidationErrorCard
          validationErrors={commissioningState.validationState.general_errors}
          sx={{ mt: 2 }}
        />
      )}
      {commissioningState.validationState.has_device_validation_errors && (
        <DeviceValidationErrorCard
          deviceErrors={commissioningState.validationState.device_validation_errors}
          sx={{ mt: 2 }}
        />
      )}
    </div>
  );
};
